import React, { useEffect, useState } from 'react';

const AboutMe = ({ description, handleProfileEdit, isLoggedInUser }) => {
    const [editMode, setEditMode] = useState(false);
    const [desc, setDesc] = useState(description || '');
    const [error, setError] = useState('');

    useEffect(() => {
        setDesc(description || '');
    }, [description]);

    const handleCancelEdit = () => {
        setEditMode(false);
        setDesc(description || '');
        setError('');
    };

    const handleSave = async () => {
        setError('');
        try {
            await handleProfileEdit({ description: desc });
            setEditMode(false);
        } catch (err) {
            setError(err.response?.data?.detail || 'Unable to save changes.');
        }
    };

    return (
        <section className="profile-card about-me">
            <div className="profile-card-header">
                <div>
                    <p className="profile-card-kicker">Profile</p>
                    <h4>About</h4>
                </div>
                {isLoggedInUser && !editMode && (
                    <button
                        className="profile-icon-button"
                        type="button"
                        aria-label="Edit about me"
                        onClick={() => setEditMode(true)}
                    >
                        <i className="bi-pencil-square" />
                    </button>
                )}
            </div>
            {editMode ? (
                <>
                    <textarea
                        className="profile-field profile-textarea"
                        value={desc}
                        onChange={(e) => setDesc(e.target.value)}
                        placeholder="Share your investing style, interests, or current focus."
                    />
                    <div className="profile-action-row">
                        <button
                            className="btn profile-secondary-button"
                            type="button"
                            onClick={handleCancelEdit}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn profile-primary-button"
                            type="button"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </div>
                </>
            ) : (
                <p className="profile-card-body">
                    {desc || 'No profile description yet.'}
                </p>
            )}
            {error && <p className="profile-inline-error">{error}</p>}
        </section>
    );
};

export default AboutMe;
